import { default as appStore } from '../../utilities/store';
import Keys from '../../stateKeys';
import isStringSet from '../../utilities/is/isStringSet';
import HttpStatus from './httpStatus';
import { updateToken } from 'workers/mediator';

export function handleError(error) {
    return Promise.reject("The Internet connection appears to be offline.");
}

export function handleResponse(response) {

    if (response.status === HttpStatus.NotAuthorized
        || response.status === HttpStatus.RefreshTokenRequired) {

        if (window.location.href !== '/login') {
            window.location.href = '/login';
            appStore.remove(Keys.Auth.TokenKey);
            updateToken(null);
            window.location.reload();
        }

        return;
    }

    if (response.status === HttpStatus.Forbidden) {
        return response.text().then(text => {
            const error = JSON.parse(text);
            if (error && error.message) {
                return Promise.reject("There was a problem contacting the server: " + error.message);
            } else {
                return Promise.reject("There was a problem contacting the server");
            }
        }).catch(err => {
            return Promise.reject(err || "There was a problem contacting the server");
        })
    }

    if (!response.ok) {
        throw Error(response.statusText);
    }

    const token = response.headers.get('X-Session-Token');
    if (isStringSet(token)) {
        appStore.set(Keys.Auth.TokenKey, token);
        updateToken(token);
    }

    return response.text().then(text => {
        try {
            const data = text && JSON.parse(text);
            return data;
        } catch (err) {
            console.error(err);
            return {};
        }
    });
}